import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingCycle = ( { billingCycle, className, text } ) => {
    const { t } = useTranslation();

    const billingCycles = {
        monthly: t('billing.monthly'),
        annual: t('billing.annual'),
    };

    return (
        <span className={className}>{text && `${text}`}{billingCycles[billingCycle]}</span>
    );
};

export default BillingCycle;
